export const propertiesObject = {
  AppSyncOpenIDConnectConfig: {
    properties: [
      {
        description: "OBJECTPROPERTIES.APPSYNCOPENIDCONNECTCONFIG.PROPERTIES.AUTHTTL.DESCRIPTION",
        key: "AuthTTL",
        label: "OBJECTPROPERTIES.APPSYNCOPENIDCONNECTCONFIG.PROPERTIES.AUTHTTL.LABEL",
        type: "integer",
        validation: {
          regex: "^(^[1-9][0-9]*)$",
          regexErrMsg: "OBJECTPROPERTIES.APPSYNCOPENIDCONNECTCONFIG.PROPERTIES.AUTHTTL.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.APPSYNCOPENIDCONNECTCONFIG.PROPERTIES.CLIENTID.DESCRIPTION",
        key: "ClientId",
        label: "OBJECTPROPERTIES.APPSYNCOPENIDCONNECTCONFIG.PROPERTIES.CLIENTID.LABEL",
        type: "string"
      },
      {
        description: "OBJECTPROPERTIES.APPSYNCOPENIDCONNECTCONFIG.PROPERTIES.FIELDLOGLEVEL.DESCRIPTION",
        key: "FieldLogLevel",
        label: "OBJECTPROPERTIES.APPSYNCOPENIDCONNECTCONFIG.PROPERTIES.FIELDLOGLEVEL.LABEL",
        type: "select<AppSyncLogLevel>"
      }
    ]
  },
  HeaderObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.HEADEROBJECT.PROPERTIES.NAME.DESCRIPTION",
        key: "Name",
        label: "OBJECTPROPERTIES.HEADEROBJECT.PROPERTIES.NAME.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 200,
          minLength: 1
        }
      },
      {
        description: "OBJECTPROPERTIES.HEADEROBJECT.PROPERTIES.VALUE.DESCRIPTION",
        key: "Value",
        label: "OBJECTPROPERTIES.HEADEROBJECT.PROPERTIES.VALUE.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 200,
          minLength: 1
        }
      }
    ]
  },
  ResponseTemplateObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.RESPONSETEMPLATEOBJECT.PROPERTIES.CONTENTTYPE.DESCRIPTION",
        key: "ContentType",
        label: "OBJECTPROPERTIES.RESPONSETEMPLATEOBJECT.PROPERTIES.CONTENTTYPE.LABEL",
        required: true,
        type: "string"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.RESPONSETEMPLATEOBJECT.PROPERTIES.TEMPLATE.DESCRIPTION",
        key: "Template",
        label: "OBJECTPROPERTIES.RESPONSETEMPLATEOBJECT.PROPERTIES.TEMPLATE.LABEL",
        required: true,
        type: "string"
      }
    ]
  },
  VPCID: {
    properties: [
      {
        description: "OBJECTPROPERTIES.VPCID.PROPERTIES.VPCID.DESCRIPTION",
        key: "VPCID",
        label: "OBJECTPROPERTIES.VPCID.PROPERTIES.VPCID.LABEL",
        required: true,
        type: "string",
        validation: {
          regex: "^vpc-([a-z0-9])*$",
          regexErrMsg: "OBJECTPROPERTIES.VPCID.PROPERTIES.VPCID.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  WSAuthorizerObject: {
    label: "OBJECTPROPERTIES.WSAUTHORIZEROBJECT.PROPERTIES",
    properties: [
      {
        description: "OBJECTPROPERTIES.WSAUTHORIZEROBJECT.PROPERTIES.AUTHID.DESCRIPTION",
        key: "AuthID",
        label: "OBJECTPROPERTIES.WSAUTHORIZEROBJECT.PROPERTIES.AUTHID.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 30,
          minLength: 3,
          regex: "^[A-Za-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.WSAUTHORIZEROBJECT.PROPERTIES.AUTHID.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.WSAUTHORIZEROBJECT.PROPERTIES.PARAMETERS.DESCRIPTION",
        key: "Parameters",
        label: "OBJECTPROPERTIES.WSAUTHORIZEROBJECT.PROPERTIES.PARAMETERS.LABEL",
        required: true,
        type: "parametersAuthObjectCustomRequest"
      }
    ]
  },
  alarmDimensions: {
    properties: [
      {
        description: "OBJECTPROPERTIES.ALARMOBJECT.PROPERTIES.DIMENSIONS.DIMENSIONNAME.DESCRIPTION",
        idRequired: "mapfreName",
        key: "Name",
        label: "OBJECTPROPERTIES.ALARMOBJECT.PROPERTIES.DIMENSIONS.DIMENSIONNAME.LABEL",
        required: false,
        type: "string",
        validation: {
          maxLength: 255,
          minLength: 3,
          regex: "^[a-zA-z0-9][-_a-zA-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.ALARMOBJECT.PROPERTIES.NAME.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.ALARMOBJECT.PROPERTIES.DIMENSIONS.DIMENSIONVALUE.DESCRIPTION",
        idRequired: "mapfreName",
        key: "Value",
        label: "OBJECTPROPERTIES.ALARMOBJECT.PROPERTIES.DIMENSIONS.DIMENSIONVALUE.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 255,
          minLength: 3,
          regex: "^[a-zA-z0-9:_-][-_a-zA-z0-9:_-]*$",
          regexErrMsg: "OBJECTPROPERTIES.ALARMOBJECT.PROPERTIES.NAME.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  aliasObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.ALIASOBJECT.PROPERTIES.ALIASNAME.DESCRIPTION",
        key: "AliasName",
        label: "OBJECTPROPERTIES.ALIASOBJECT.PROPERTIES.ALIASNAME.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 15,
          minLength: 1,
          regex: "^[A-Za-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.ALIASOBJECT.PROPERTIES.ALIASNAME.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.ALIASOBJECT.PROPERTIES.VERSION.DESCRIPTION",
        key: "Version",
        label: "OBJECTPROPERTIES.ALIASOBJECT.PROPERTIES.VERSION.LABEL",
        placeholder: "OBJECTPROPERTIES.ALIASOBJECT.PROPERTIES.VERSION.PLACEHOLDER",
        type: "integer",
        validation: {
          regex: "^(null||undefined|[0-9]*)$",
          regexErrMsg: "OBJECTPROPERTIES.ALIASOBJECT.PROPERTIES.VERSION.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  apiConfigVPC: {
    properties: [
      {
        advanced: true,
        description: "OBJECTPROPERTIES.APICONFIGVPC.PROPERTIES.VPC.DESCRIPTION",
        key: "VPC",
        label: "OBJECTPROPERTIES.APICONFIGVPC.PROPERTIES.VPC.LABEL",
        type: "array<VPCID>"
      }
    ]
  },
  apiGatewayRoute: {
    properties: [
      {
        description: "OBJECTPROPERTIES.APIGATEWAYROUTE.PROPERTIES.NAME.DESCRIPTION",
        key: "Name",
        label: "OBJECTPROPERTIES.APIGATEWAYROUTE.PROPERTIES.NAME.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 50,
          minLength: 3,
          regex: "(^[{a-zA-Z0-9][-._{}a-zA-Z0-9]*$)|(^\\$connect$)|(^\\$disconnect$)|(^\\$default$)",
          regexErrMsg: "OBJECTPROPERTIES.APIGATEWAYROUTE.PROPERTIES.NAME.VALIDATION.REGEX_ERROR_MSG",
          unique: true
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.APIGATEWAYROUTE.PROPERTIES.AUTHID.DESCRIPTION",
        key: "AuthID",
        label: "OBJECTPROPERTIES.APIGATEWAYROUTE.PROPERTIES.AUTHID.LABEL",
        type: "select<authProper<WSAuthorizerObject>>",
        visibility: {
          comparator: "eq",
          field: "Name",
          value: "$connect"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.APIGATEWAYROUTE.PROPERTIES.INTEGRATION.DESCRIPTION",
        hiddenInModal: true,
        key: "Integration",
        label: "OBJECTPROPERTIES.APIGATEWAYROUTE.PROPERTIES.INTEGRATION.LABEL",
        onChangeActions: [
          {
            action: "changePropertyType",
            replaceWith: "actionValue",
            target: "IntegrationParameters"
          }
        ],
        required: true,
        type: "select<typeWSIntegration>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.APIGATEWAYROUTE.PROPERTIES.INTEGRATIONPARAMETERS.DESCRIPTION",
        hiddenInModal: true,
        key: "IntegrationParameters",
        label: "OBJECTPROPERTIES.APIGATEWAYROUTE.PROPERTIES.INTEGRATIONPARAMETERS.LABEL",
        type: "integracionParametersObjectLambda",
        visibility: {
          comparator: "notnull",
          field: "Integration"
        }
      }
    ]
  },
  authorizerObject: {
    label: "OBJECTPROPERTIES.AUTHORIZEROBJECT.LABEL",
    properties: [
      {
        description: "OBJECTPROPERTIES.AUTHORIZEROBJECT.PROPERTIES.AUTHID.DESCRIPTION",
        key: "AuthID",
        label: "OBJECTPROPERTIES.AUTHORIZEROBJECT.PROPERTIES.AUTHID.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 20,
          minLength: 3,
          regex: "^[A-Za-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.AUTHORIZEROBJECT.PROPERTIES.AUTHID.VALIDATION.REGEX_ERROR_MSG",
          unique: true
        }
      },
      {
        description: "OBJECTPROPERTIES.AUTHORIZEROBJECT.PROPERTIES.TYPE.DESCRIPTION",
        key: "Type",
        label: "OBJECTPROPERTIES.AUTHORIZEROBJECT.PROPERTIES.TYPE.LABEL",
        onChangeActions: [
          {
            action: "changePropertyType",
            replaceWith: "actionValue",
            target: "Parameters"
          }
        ],
        required: true,
        type: "select<typeAuth>"
      },
      {
        description: "OBJECTPROPERTIES.AUTHORIZEROBJECT.PROPERTIES.TTL.DESCRIPTION",
        key: "AuthorizerResultTtlInSeconds",
        label: "OBJECTPROPERTIES.AUTHORIZEROBJECT.PROPERTIES.TTL.LABEL",
        required: false,
        type: "integer",
        validation: {
          max: 3600,
          min: 0,
          regex: "^(^[0-9][0-9]*)$",
          regexErrMsg: "OBJECTPROPERTIES.AUTHORIZEROBJECT.PROPERTIES.TTL.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.AUTHORIZEROBJECT.PROPERTIES.PARAMETERS.DESCRIPTION",
        key: "Parameters",
        label: "OBJECTPROPERTIES.AUTHORIZEROBJECT.PROPERTIES.PARAMETERS.LABEL",
        type: "parametersAuthObjectOauth"
      }
    ]
  },
  backupObject: {
    properties: [
      {
        default: "",
        description: "OBJECTPROPERTIES.BACKUPOBJECT.PROPERTIES.SCHEDULE.DESCRIPTION",
        key: "Schedule",
        label: "OBJECTPROPERTIES.BACKUPOBJECT.PROPERTIES.SCHEDULE.LABEL",
        placeholder: "OBJECTPROPERTIES.BACKUPOBJECT.PROPERTIES.SCHEDULE.PLACEHOLDER",
        required: true,
        type: "string",
        validation: {
          maxLength: 100,
          minLenth: 17,
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.BACKUPOBJECT.PROPERTIES.SCHEDULE.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  certificateObject: {
    properties: [
      {
        advanced: true,
        description: "OBJECTPROPERTIES.CERTIFICATEOBJECT.PROPERTIES.TYPE.DESCRIPTION",
        key: "Type",
        label: "OBJECTPROPERTIES.CERTIFICATEOBJECT.PROPERTIES.TYPE.LABEL",
        type: "select<typeCertificate>",
        validation: {
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.CERTIFICATEOBJECT.PROPERTIES.TYPE.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.CERTIFICATEOBJECT.PROPERTIES.FILEPUBLIC.DESCRIPTION",
        key: "FilePublic",
        label: "OBJECTPROPERTIES.CERTIFICATEOBJECT.PROPERTIES.FILEPUBLIC.LABEL",
        type: "file",
        uploadFolder: "webhost/certificate",
        visibility: {
          comparator: "eq",
          field: "Type",
          value: "IMPORT"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.CERTIFICATEOBJECT.PROPERTIES.FILEPRIVATE.DESCRIPTION",
        key: "FilePrivate",
        label: "OBJECTPROPERTIES.CERTIFICATEOBJECT.PROPERTIES.FILEPRIVATE.LABEL",
        type: "file",
        uploadFolder: "webhost/certificate",
        visibility: {
          comparator: "eq",
          field: "Type",
          value: "IMPORT"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.CERTIFICATEOBJECT.PROPERTIES.FILECHAIN.DESCRIPTION",
        key: "FileChain",
        label: "OBJECTPROPERTIES.CERTIFICATEOBJECT.PROPERTIES.FILECHAIN.LABEL",
        type: "file",
        uploadFolder: "webhost/certificate",
        visibility: {
          comparator: "eq",
          field: "Type",
          value: "IMPORT"
        }
      }
    ]
  },
  configurationAlarmsObject: {
    properties: [
      {
        advanced: false,
        description: "OBJECTPROPERTIES.CONFIGURATIONALARMSOBJECT.PROPERTIES.EMAILTO.DESCRIPTION",
        key: "emailTo",
        label: "OBJECTPROPERTIES.CONFIGURATIONALARMSOBJECT.PROPERTIES.EMAILTO.LABEL",
        type: "string",
        validation: {
          maxLength: 30,
          minLength: 3,
          regex: "^[^@]+@[^@]+.[a-zA-Z]{2,}$",
          regexErrMsg: "OBJECTPROPERTIES.CONFIGURATIONALARMSOBJECT.PROPERTIES.EMAILTO.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  lifecycleRules: {
    properties: [
      {
        required: false,
        advanced: true,
        description: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.STATUS.DESCRIPTION",
        key: "Status",
        label: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.STATUS.LABEL",
        type: "boolean",
      },
      {
        required: true,
        advanced: false,
        description: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.ID.DESCRIPTION",
        key: "Id",
        label: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.ID.LABEL",
        placeholder: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.ID.PLACEHOLDER",
        type: "string"
      },
      {
        advanced: false,
        description: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.EXPDAYS.DESCRIPTION",
        key: "ExpirationInDays",
        label: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.EXPDAYS.LABEL",
        placeholder: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.EXPDAYS.PLACEHOLDER",
        type: "integer",
        validation: {
          maxLength: 200
        }
      },
      {
        advanced: false,
        description: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.PREFIX.DESCRIPTION",
        key: "Prefix",
        label: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.PREFIX.LABEL",
        placeholder: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.PREFIX.PLACEHOLDER",
        type: "string",
        validation: {
          maxLength: 1024
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.EXPOBJMARKER.DESCRIPTION",
        key: "ExpiredObjectDeleteMarker",
        label: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.EXPOBJMARKER.LABEL",
        type: "boolean"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.NONCURRENTEXPINDAYS.DESCRIPTION",
        key: "NoncurrentVersionExpirationInDays",
        label: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.NONCURRENTEXPINDAYS.LABEL",
        type: "integer"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.OBJSIZEGT.DESCRIPTION",
        key: "ObjectSizeGreaterThan",
        label: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.OBJSIZEGT.LABEL",
        placeholder: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.OBJSIZEGT.PLACEHOLDER",
        type: "integer"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.OBJSIZELT.DESCRIPTION",
        key: "ObjectSizeLessThan",
        label: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.OBJSIZELT.LABEL",
        placeholder: "OBJECTPROPERTIES.LIFECYCLE.PROPERTIES.OBJSIZELT.PLACEHOLDER",
        type: "integer"
      },
    ]
  },
  replicationRules: {
    properties: [
      {
        required: false,
        advanced: false,
        description: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.STATUS.DESCRIPTION",
        key: "Status",
        label: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.STATUS.LABEL",
        type: "boolean"
      },
      {
        required: true,
        advanced: false,
        description: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.ID.DESCRIPTION",
        key: "Id",
        label: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.ID.LABEL",
        placeholder: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.ID.PLACEHOLDER",
        type: "string"
      },
      {
        required: true,
        advanced: false,
        description: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.BUCKETDESTINATION.DESCRIPTION",
        key: "Bucket",
        label: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.BUCKETDESTINATION.LABEL",
        placeholder: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.BUCKETDESTINATION.PLACEHOLDER",
        type: "string",
        validation: {
          regex: "^arn:aws:s3:::[a-z0-9](?:[a-z0-9.-]{1,61}[a-z0-9])?$"
        }
      },
      {
        required: false,
        advanced: false,
        description: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.CRR.DESCRIPTION",
        key: "CRR",
        label: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.CRR.LABEL",
        type: "boolean"
      },
      {
        required: false,
        advanced: false,
        description: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.REGIONS.DESCRIPTION",
        key: "Region",
        label: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.REGIONS.LABEL",
        type: "select<regions>",
        visibility: {
          comparator: "eq",
          field: "CRR",
          value: true
        }
      },
      {
        advanced: false,
        description: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.PREFIX.DESCRIPTION",
        key: "Prefix",
        label: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.PREFIX.LABEL",
        placeholder: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.PREFIX.PLACEHOLDER",
        type: "string",
        validation: {
          maxLength: 1024
        }
      },
      {
        required: true,
        advanced: false,
        description: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.PRIORITY.DESCRIPTION",
        key: "Priority",
        label: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.PRIORITY.LABEL",
        type: "integer"
      },
      {
        required: true,
        advanced: true,
        description: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.DELETEMARKER.DESCRIPTION",
        key: "DeleteMarkerReplication",
        label: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.DELETEMARKER.LABEL",
        type: "boolean"
      },
    ]
  },
  secondaryReplicationRules: {
    properties: [
      {
        required: false,
        advanced: false,
        description: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.STATUS.DESCRIPTION",
        key: "Status",
        label: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.STATUS.LABEL",
        type: "boolean"
      },
      {
        required: true,
        advanced: false,
        description: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.ID.DESCRIPTION",
        key: "Id",
        label: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.ID.LABEL",
        placeholder: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.ID.PLACEHOLDER",
        type: "string"
      },
      {
        required: true,
        advanced: false,
        description: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.BUCKETDESTINATION.DESCRIPTION",
        key: "Bucket",
        label: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.BUCKETDESTINATION.LABEL",
        placeholder: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.BUCKETDESTINATION.PLACEHOLDER",
        type: "string",
        validation: {
          regex: "^arn:aws:s3:::[a-z0-9](?:[a-z0-9.-]{1,61}[a-z0-9])?$"
        }
      },
      {
        required: false,
        advanced: false,
        description: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.CRR.DESCRIPTION",
        key: "CRR",
        label: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.CRR.LABEL",
        type: "boolean"
      },
      {
        required: false,
        advanced: false,
        description: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.REGIONS.DESCRIPTION",
        key: "Region",
        label: "OBJECTPROPERTIES.REPLICATION.PROPERTIES.REGIONS.LABEL",
        type: "select<regions>",
        visibility: {
          comparator: "eq",
          field: "CRR",
          value: true
        }
      },
      {
        advanced: false,
        description: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.PREFIX.DESCRIPTION",
        key: "Prefix",
        label: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.PREFIX.LABEL",
        placeholder: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.PREFIX.PLACEHOLDER",
        type: "string",
        validation: {
          maxLength: 1024
        }
      },
      {
        required: true,
        advanced: false,
        description: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.PRIORITY.DESCRIPTION",
        key: "Priority",
        label: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.PRIORITY.LABEL",
        type: "integer"
      },
      {
        required: true,
        advanced: true,
        description: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.DELETEMARKER.DESCRIPTION",
        key: "DeleteMarkerReplication",
        label: "OBJECTPROPERTIES.SECONDARYREPLICATION.PROPERTIES.DELETEMARKER.LABEL",
        type: "boolean"
      }
    ]
  },
  configurationCORS: {
    properties: [
      {
        advanced: true,
        default: "",
        description: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.METHODS.DESCRIPTION",
        key: "Methods",
        label: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.METHODS.LABEL",
        placeholder: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.METHODS.PLACEHOLDER",
        type: "string",
        validation: {
          maxLength: 100,
          minLenth: 3,
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.METHODS.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        advanced: false,
        description: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.HEADERS.DESCRIPTION",
        key: "Headers",
        label: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.HEADERS.LABEL",
        placeholder: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.HEADERS.PLACEHOLDER",
        type: "string",
        validation: {
          maxLength: 200
        }
      },
      {
        advanced: true,
        default: "",
        description: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.ORIGIN.DESCRIPTION",
        key: "Origin",
        label: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.ORIGIN.LABEL",
        placeholder: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.ORIGIN.PLACEHOLDER",
        type: "string",
        validation: {
          maxLength: 100,
          minLenth: 3,
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.ORIGIN.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        advanced: false,
        description: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.EXPOSEDHEADERS.DESCRIPTION",
        key: "ExposedHeaders",
        label: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.EXPOSEDHEADERS.LABEL",
        placeholder: "OBJECTPROPERTIES.CONFIGURATIONCORS.PROPERTIES.EXPOSEDHEADERS.PLACEHOLDER",
        type: "string",
        validation: {
          maxLength: 200
        }
      }
    ]
  },
  deploymentObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.DEPLOYMENTOBJECT.PROPERTIES.STAGENAME.DESCRIPTION",
        key: "StageName",
        label: "OBJECTPROPERTIES.DEPLOYMENTOBJECT.PROPERTIES.STAGENAME.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 30,
          minLength: 1,
          regex: "^[a-zA-Z0-9][-_a-zA-Z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.DEPLOYMENTOBJECT.PROPERTIES.STAGENAME.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.DEPLOYMENTOBJECT.PROPERTIES.DESCRIPTION.DESCRIPTION",
        key: "Description",
        label: "OBJECTPROPERTIES.DEPLOYMENTOBJECT.PROPERTIES.DESCRIPTION.LABEL",
        type: "string",
        validation: {
          maxLength: 100,
          minLength: 3
        }
      },
      {
        description: "OBJECTPROPERTIES.DEPLOYMENTOBJECT.PROPERTIES.VARIABLES.DESCRIPTION",
        key: "Variables",
        label: "OBJECTPROPERTIES.DEPLOYMENTOBJECT.PROPERTIES.VARIABLES.LABEL",
        type: "array<variableObject>"
      }
    ]
  },
  filterObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.FILTEROBJECT.PROPERTIES.NAME.DESCRIPTION",
        key: "Name",
        label: "OBJECTPROPERTIES.FILTEROBJECT.PROPERTIES.NAME.LABEL",
        required: true,
        type: "select<typeFilter>"
      },
      {
        description: "OBJECTPROPERTIES.FILTEROBJECT.PROPERTIES.VALUE.DESCRIPTION",
        key: "Value",
        label: "OBJECTPROPERTIES.FILTEROBJECT.PROPERTIES.VALUE.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 200,
          minLength: 1
        }
      }
    ]
  },
  graphQLAPILogConfig: {
    properties: [
      {
        description: "OBJECTPROPERTIES.GRAPHQLAPILOGCONFIG.PROPERTIES.CLOUDWATCHLOGSROLEARN.DESCRIPTION",
        key: "CloudWatchLogsRoleArn",
        label: "OBJECTPROPERTIES.GRAPHQLAPILOGCONFIG.PROPERTIES.CLOUDWATCHLOGSROLEARN.LABEL",
        type: "string",
        validation: {
          maxLength: 30
        }
      },
      {
        description: "OBJECTPROPERTIES.GRAPHQLAPILOGCONFIG.PROPERTIES.EXCLUDEVERBOSECONTENT.DESCRIPTION",
        key: "ExcludeVerboseContent",
        label: "OBJECTPROPERTIES.GRAPHQLAPILOGCONFIG.PROPERTIES.EXCLUDEVERBOSECONTENT.LABEL",
        type: "boolean"
      },
      {
        description: "OBJECTPROPERTIES.GRAPHQLAPILOGCONFIG.PROPERTIES.FIELDLOGLEVEL.DESCRIPTION",
        key: "FieldLogLevel",
        label: "OBJECTPROPERTIES.GRAPHQLAPILOGCONFIG.PROPERTIES.FIELDLOGLEVEL.LABEL",
        type: "select<AppSyncLogLevel>"
      }
    ]
  },
  graphQLAPIObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.GRAPHQLAPIOBJECT.PROPERTIES.NAME.DESCRIPTION",
        key: "Name",
        label: "OBJECTPROPERTIES.GRAPHQLAPIOBJECT.PROPERTIES.NAME.LABEL",
        placeholder: "OBJECTPROPERTIES.GRAPHQLAPIOBJECT.PROPERTIES.NAME.PLACEHOLDER",
        required: true,
        type: "string",
        validation: {
          maxLength: 30
        }
      },
      {
        description: "OBJECTPROPERTIES.GRAPHQLAPIOBJECT.PROPERTIES.AUTHENTICATIONTYPE.DESCRIPTION",
        key: "AuthenticationType",
        label: "OBJECTPROPERTIES.GRAPHQLAPIOBJECT.PROPERTIES.AUTHENTICATIONTYPE.LABEL",
        placeholder: "OBJECTPROPERTIES.GRAPHQLAPIOBJECT.PROPERTIES.AUTHENTICATIONTYPE.PLACEHOLDER",
        required: true,
        type: "select<graphQLAPIAuthType>"
      },
      {
        description: "OBJECTPROPERTIES.GRAPHQLAPIOBJECT.PROPERTIES.LOGCONFIG.DESCRIPTION",
        key: "LogConfig",
        label: "OBJECTPROPERTIES.GRAPHQLAPIOBJECT.PROPERTIES.LOGCONFIG.LABEL",
        type: "graphQLAPILogConfig"
      },
      {
        description: "OBJECTPROPERTIES.GRAPHQLAPIOBJECT.PROPERTIES.OPENIDCONNECTCONFIG.DESCRIPTION",
        key: "OpenIDConnectConfig",
        label: "OBJECTPROPERTIES.GRAPHQLAPIOBJECT.PROPERTIES.OPENIDCONNECTCONFIG.LABEL",
        type: "AppSyncOpenIDConnectConfig"
      }
    ]
  },
  identitySourceObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.IDENTITYSOURCEOBJECT.PROPERTIES.TYPE.DESCRIPTION",
        key: "Type",
        label: "OBJECTPROPERTIES.IDENTITYSOURCEOBJECT.PROPERTIES.TYPE.LABEL",
        required: true,
        type: "select<typeIdentitySource>"
      },
      {
        description: "OBJECTPROPERTIES.IDENTITYSOURCEOBJECT.PROPERTIES.NAME.DESCRIPTION",
        key: "Name",
        label: "OBJECTPROPERTIES.IDENTITYSOURCEOBJECT.PROPERTIES.NAME.LABEL",
        required: true,
        type: "string",
        validation: {
          regex: "[a-zA-Z0-9._-]+",
          regexErrMsg: "OBJECTPROPERTIES.IDENTITYSOURCEOBJECT.PROPERTIES.NAME.VALIDATION.REGEX_ERROR_MSG"
        },
        visibility: {
          comparator: "neq",
          field: "Type",
          value: "STAGE"
        }
      },
      {
        description: "OBJECTPROPERTIES.IDENTITYSOURCEOBJECT.PROPERTIES.NAMESTAGE.DESCRIPTION",
        editable: false,
        key: "NameStage",
        label: "OBJECTPROPERTIES.IDENTITYSOURCEOBJECT.PROPERTIES.NAMESTAGE.LABEL",
        required: true,
        type: "select<stageVariableProper<variableObject>>",
        visibility: {
          comparator: "eq",
          field: "Type",
          value: "STAGE"
        }
      }
    ]
  },
  indexObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.TYPE.DESCRIPTION",
        key: "Type",
        label: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.TYPE.LABEL",
        required: true,
        type: "select<typeIndex>",
        validation: {
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.TYPE.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.INDEXNAME.DESCRIPTION",
        key: "IndexName",
        label: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.INDEXNAME.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 30,
          minLength: 3,
          regex: "^[a-z0-9][-_a-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.INDEXNAME.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.KEYSCHEMA.DESCRIPTION",
        key: "KeySchema",
        label: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.KEYSCHEMA.LABEL",
        required: true,
        type: "keySchemaObject",
        validation: {
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.KEYSCHEMA.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.PROJECTION.DESCRIPTION",
        key: "Projection",
        label: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.PROJECTION.LABEL",
        required: true,
        type: "projectionObject",
        validation: {
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.PROJECTION.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.PROVISIONEDUNITS.DESCRIPTION",
        key: "ProvisionedUnits",
        label: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.PROVISIONEDUNITS.LABEL",
        type: "provisionedObject",
        validation: {
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.INDEXOBJECT.PROPERTIES.PROVISIONEDUNITS.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  integracionParametersObjectCPDVPCLambda: {
    properties: [
      {
        description: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.FUNCTIONNAME.DESCRIPTION",
        key: "FunctionName",
        label: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.FUNCTIONNAME.LABEL",
        required: true,
        type: "select<node<lamvpcm>>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.ALIAS.DESCRIPTION",
        key: "Alias",
        label: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.ALIAS.LABEL",
        type: "string",
        validation: {
          maxLength: 15,
          minLength: 3,
          regex: "^[A-Za-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.ALIAS.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  integracionParametersObjectHTTP: {
    properties: [
      {
        description: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTHTTP.PROPERTIES.URL.DESCRIPTION",
        key: "Url",
        label: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTHTTP.PROPERTIES.URL.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 200,
          minLength: 4,
          regex: "\\w+:(\\/?\\/?)[^\\s]+",
          regexErrMsg: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTHTTP.PROPERTIES.URL.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTHTTP.PROPERTIES.METHOD.DESCRIPTION",
        key: "Method",
        label: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTHTTP.PROPERTIES.METHOD.LABEL",
        type: "select<typeHttpMethod>"
      }
    ]
  },
  integracionParametersObjectLambda: {
    properties: [
      {
        description: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.FUNCTIONNAME.DESCRIPTION",
        key: "FunctionName",
        label: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.FUNCTIONNAME.LABEL",
        required: true,
        type: "select<node<lambda>>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.ALIAS.DESCRIPTION",
        key: "Alias",
        label: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.ALIAS.LABEL",
        type: "string",
        validation: {
          maxLength: 15,
          minLength: 3,
          regex: "^[A-Za-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.ALIAS.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  integracionParametersObjectProjectVPCLambda: {
    properties: [
      {
        description: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.FUNCTIONNAME.DESCRIPTION",
        key: "FunctionName",
        label: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.FUNCTIONNAME.LABEL",
        required: true,
        type: "select<node<lamvpc>>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.ALIAS.DESCRIPTION",
        key: "Alias",
        label: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.ALIAS.LABEL",
        type: "string",
        validation: {
          maxLength: 15,
          minLength: 3,
          regex: "^[A-Za-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDA.PROPERTIES.ALIAS.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  integracionParametersObjectProxyLambda: {
    properties: [
      {
        description: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDAPROXY.PROPERTIES.FUNCTIONNAME.DESCRIPTION",
        key: "FunctionName",
        label: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDAPROXY.PROPERTIES.FUNCTIONNAME.LABEL",
        required: true,
        type: "select<node<lambda>>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDAPROXY.PROPERTIES.ALIAS.DESCRIPTION",
        key: "Alias",
        label: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDAPROXY.PROPERTIES.ALIAS.LABEL",
        type: "string",
        validation: {
          maxLength: 15,
          minLength: 3,
          regex: "^[A-Za-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.INTEGRACIONPARAMETERSOBJECTLAMBDAPROXY.PROPERTIES.ALIAS.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  keySchemaObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.PARTITIONKEY.DESCRIPTION",
        key: "PartitionKey",
        label: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.PARTITIONKEY.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 50,
          minLength: 1,
          notEqual: "SortKey",
          regex: "(^([A-Za-z0-9]))(([-_a-z0-9])*)",
          regexErrMsg: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.PARTITIONKEY.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.TYPEPARTITIONKEY.DESCRIPTION",
        key: "TypePartitionKey",
        label: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.TYPEPARTITIONKEY.LABEL",
        required: true,
        type: "select<typeKey>",
        validation: {
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.TYPEPARTITIONKEY.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.SORTKEY.DESCRIPTION",
        key: "SortKey",
        label: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.SORTKEY.LABEL",
        type: "string",
        validation: {
          maxLength: 50,
          minLength: 1,
          notEqual: "PartitionKey",
          regex: "^[A-Za-z0-9][-_A-Za-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.SORTKEY.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.TYPESORTKEY.DESCRIPTION",
        key: "TypeSortKey",
        label: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.TYPESORTKEY.LABEL",
        type: "select<typeKey>",
        validation: {
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.KEYSCHEMAOBJECT.PROPERTIES.TYPESORTKEY.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  lambdaAuthorizerObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.NAME.DESCRIPTION",
        disabled: true,
        key: "Name",
        label: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.NAME.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 30,
          minLength: 3,
          regex: "^[A-Za-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.NAME.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.FUNCTIONNAME.DESCRIPTION",
        key: "FunctionName",
        label: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.FUNCTIONNAME.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 30,
          minLength: 3,
          regex: "^[a-z0-9][-_a-z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.FUNCTIONNAME.VALIDATION.REGEX_ERROR_MSG",
          unique: true
        }
      },
      {
        advanced: true,
        default: "nodejs16.x",
        description: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.RUNTIME.DESCRIPTION",
        key: "Runtime",
        label: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.RUNTIME.LABEL",
        required: true,
        type: "select<typeLambdaRuntimes>"
      },
      {
        advanced: true,
        default: "365",
        description: "NODESPROPERTIES.LAMBDA.PROPERTIES.RETENTIONLOGSPERIOD.DESCRIPTION",
        key: "RetentionLogsPeriod",
        label: "NODESPROPERTIES.LAMBDA.PROPERTIES.RETENTIONLOGSPERIOD.LABEL",
        required: true,
        type: "select<retentionLogsPeriod>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.HANDLER.DESCRIPTION",
        key: "Handler",
        label: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.HANDLER.LABEL",
        placeholder: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.HANDLER.PLACEHOLDER",
        type: "string",
        validation: {
          maxLength: 50,
          minLength: 3
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.VARIABLES.DESCRIPTION",
        key: "Variables",
        label: "OBJECTPROPERTIES.LAMBDAAUTHORIZEROBJECT.PROPERTIES.VARIABLES.LABEL",
        type: "array<variableObject>"
      }
    ]
  },
  lambdaConfigVPC: {
    properties: [
      {
        description: "OBJECTPROPERTIES.VPCCONFIG.PROPERTIES.VPCTYPE.DESCRIPTION",
        key: "VPCType",
        label: "OBJECTPROPERTIES.VPCCONFIG.PROPERTIES.VPCTYPE.LABEL",
        onChangeActions: [
          {
            action: "changeNodeLogo",
            replaceWith: "logoValue"
          }
        ],
        required: true,
        type: "select<VPCType>",
        validation: {
          regex: "^(INTERNET|PRIVATE)$",
          regexErrMsg: "OBJECTPROPERTIES.VPCCONFIG.PROPERTIES.VPCTYPE.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  mapfreLambdaConfigVPC: {
    properties: [
      {
        default: "CPD",
        description: "OBJECTPROPERTIES.VPCCONFIG.PROPERTIES.VPCTYPE.DESCRIPTION",
        key: "VPCType",
        label: "OBJECTPROPERTIES.VPCCONFIG.PROPERTIES.VPCTYPE.LABEL",
        type: "string"
      }
    ]
  },
  methodIntegrationObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.METHODINTEGRATIONOBJECT.PROPERTIES.STATUSCODE.DESCRIPTION",
        key: "StatusCode",
        label: "OBJECTPROPERTIES.METHODINTEGRATIONOBJECT.PROPERTIES.STATUSCODE.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 8,
          minLength: 1,
          regex: "^[0-9-]*$",
          regexErrMsg: "OBJECTPROPERTIES.METHODINTEGRATIONOBJECT.PROPERTIES.STATUSCODE.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.METHODINTEGRATIONOBJECT.PROPERTIES.LAMBDAOUTPUTREGEX.DESCRIPTION",
        key: "LambdaOutputRegex",
        label: "OBJECTPROPERTIES.METHODINTEGRATIONOBJECT.PROPERTIES.LAMBDAOUTPUTREGEX.LABEL",
        required: false,
        type: "string",
        validation: {
          maxLength: 8000,
          minLength: 1
        }
      },
      {
        description: "OBJECTPROPERTIES.METHODINTEGRATIONOBJECT.PROPERTIES.MAPPINGRESPONSE.DESCRIPTION",
        key: "MappingResponse",
        label: "OBJECTPROPERTIES.METHODINTEGRATIONOBJECT.PROPERTIES.MAPPINGRESPONSE.LABEL",
        required: false,
        type: "string",
        validation: {
          maxLength: 8000,
          minLength: 1
        }
      }
    ]
  },
  methodObject: {
    properties: [
      {
        advanced: true,
        description: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.METHOD.DESCRIPTION",
        key: "Method",
        label: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.METHOD.LABEL",
        type: "select<typeHttpMethod>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.CORS.DESCRIPTION",
        key: "CORS",
        label: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.CORS.LABEL",
        type: "boolean"
      },

      {
        advanced: true,
        description: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.CORSPARAMETERS.DESCRIPTION",
        key: "CORSParameters",
        label: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.CORSPARAMETERS.LABEL",
        type: "configurationCORS",
        validation: {
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.CORSPARAMETERS.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.AUTHID.DESCRIPTION",
        key: "AuthID",
        label: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.AUTHID.LABEL",
        type: "select<authProper<Authorizer>>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.INTEGRATION.DESCRIPTION",
        hiddenInModal: true,
        key: "Integration",
        label: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.INTEGRATION.LABEL",
        onChangeActions: [
          {
            action: "changePropertyType",
            replaceWith: "actionValue",
            target: "IntegrationParameters"
          }
        ],
        type: "select<typeIntegration>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.INTEGRATIONPARAMETERS.DESCRIPTION",
        hiddenInModal: true,
        key: "IntegrationParameters",
        label: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.INTEGRATIONPARAMETERS.LABEL",
        type: "integracionParametersObjectLambda",
        visibility: {
          comparator: "notnull",
          field: "Integration"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.INTEGRATIONRESPONSE.DESCRIPTION",
        key: "IntegrationResponse",
        label: "OBJECTPROPERTIES.METHODOBJECT.PROPERTIES.INTEGRATIONRESPONSE.LABEL",
        type: "array<methodIntegrationObject>"
      }
    ]
  },
  parametersAuthObjectBasic: {
    fieldToDisplay: "Url",
    properties: [
      {
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTBASIC.PROPERTIES.URL.DESCRIPTION",
        key: "Url",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTBASIC.PROPERTIES.URL.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 200,
          regex:
            "^((https|http|ftp|rtsp|mms)?://)?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?(([0-9]{1,3}.){3}[0-9]{1,3}|([0-9a-z_!~*'()-]+.)*([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].[a-z]{2,6})(:[0-9]{1,4})?((/?)|(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$",
          regexErrMsg: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTBASIC.PROPERTIES.URL.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTBASIC.PROPERTIES.METHOD.DESCRIPTION",
        key: "Method",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTBASIC.PROPERTIES.METHOD.LABEL",
        type: "select<typeHttpMethod>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTBASIC.PROPERTIES.TOKEN.DESCRIPTION",
        key: "Token",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTBASIC.PROPERTIES.TOKEN.LABEL",
        type: "string",
        validation: {
          maxLength: 200,
          regex: "^[A-Za-z0-9-_]*$",
          regexErrMsg: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTBASIC.PROPERTIES.TOKEN.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  parametersAuthObjectCustomRequest: {
    properties: [
      {
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTCUSTOMREQUEST.PROPERTIES.FUNCTION.DESCRIPTION",
        key: "Function",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTCUSTOMREQUEST.PROPERTIES.FUNCTION.LABEL",
        required: true,
        type: "lambdaAuthorizerObject"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTCUSTOMREQUEST.PROPERTIES.IDENTITYSOURCES.DESCRIPTION",
        key: "IdentitySources",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTCUSTOMREQUEST.PROPERTIES.IDENTITYSOURCES.LABEL",
        type: "array<identitySourceObject>"
      }
    ]
  },
  parametersAuthObjectCustomToken: {
    properties: [
      {
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTCUSTOMTOKEN.PROPERTIES.FUNCTION.DESCRIPTION",
        key: "Function",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTCUSTOMTOKEN.PROPERTIES.FUNCTION.LABEL",
        required: true,
        type: "lambdaAuthorizerObject"
      },
      {
        advanced: true,
        default: "Authorization",
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTCUSTOMTOKEN.PROPERTIES.HEADER.DESCRIPTION",
        key: "Header",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTCUSTOMTOKEN.PROPERTIES.HEADER.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 200
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTCUSTOMTOKEN.PROPERTIES.VALIDATIONREGEXP.DESCRIPTION",
        key: "ValidationRegexp",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTCUSTOMTOKEN.PROPERTIES.VALIDATIONREGEXP.LABEL",
        type: "string"
      }
    ]
  },
  parametersAuthObjectJwt: {
    properties: [
      {
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTJWT.PROPERTIES.SECRET.DESCRIPTION",
        key: "Secret",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTJWT.PROPERTIES.SECRET.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 200,
          regex: "^[A-Za-z0-9-_]*$",
          regexErrMsg: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTJWT.PROPERTIES.SECRET.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  parametersAuthObjectOauth: {
    properties: [
      {
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTOAUTH.PROPERTIES.URL.DESCRIPTION",
        key: "Url",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTOAUTH.PROPERTIES.URL.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 200,
          minLength: 4,
          regex:
            "^((https|http|ftp|rtsp|mms)?://)?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?(([0-9]{1,3}.){3}[0-9]{1,3}|([0-9a-z_!~*'()-]+.)*([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].[a-z]{2,6})(:[0-9]{1,4})?((/?)|(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$",
          regexErrMsg: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTOAUTH.PROPERTIES.URL.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTOAUTH.PROPERTIES.METHOD.DESCRIPTION",
        key: "Method",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTOAUTH.PROPERTIES.METHOD.LABEL",
        type: "select<typeHttpMethod>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTOAUTH.PROPERTIES.TOKEN.DESCRIPTION",
        key: "Token",
        label: "OBJECTPROPERTIES.PARAMETERSAUTHOBJECTOAUTH.PROPERTIES.TOKEN.LABEL",
        type: "string",
        validation: {
          maxLength: 200
        }
      }
    ]
  },
  projectionObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.PROJECTIONOBJECT.PROPERTIES.TYPE.DESCRIPTION",
        key: "Type",
        label: "OBJECTPROPERTIES.PROJECTIONOBJECT.PROPERTIES.TYPE.LABEL",
        required: true,
        type: "select<typeProjection>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.PROJECTIONOBJECT.PROPERTIES.NONKEYATTRIBUTES.DESCRIPTION",
        key: "NonKeyAttributes",
        label: "OBJECTPROPERTIES.PROJECTIONOBJECT.PROPERTIES.NONKEYATTRIBUTES.LABEL",
        type: "array<string>",
        validation: {
          maxLength: 30,
          minLength: 3,
          regex: "^[a-zA-Z0-9][-._a-zA-Z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.PROJECTIONOBJECT.PROPERTIES.NONKEYATTRIBUTES.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  provisionedObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.PROVISIONEDOBJECT.PROPERTIES.READUNITS.DESCRIPTION",
        key: "ReadUnits",
        label: "OBJECTPROPERTIES.PROVISIONEDOBJECT.PROPERTIES.READUNITS.LABEL",
        required: true,
        type: "integer",
        validation: {
          max: 100,
          min: 1,
          regex: "^(^[1-9][0-9]*)$",
          regexErrMsg: "OBJECTPROPERTIES.PROVISIONEDOBJECT.PROPERTIES.READUNITS.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.PROVISIONEDOBJECT.PROPERTIES.WRITEUNITS.DESCRIPTION",
        key: "WriteUnits",
        label: "OBJECTPROPERTIES.PROVISIONEDOBJECT.PROPERTIES.WRITEUNITS.LABEL",
        required: true,
        type: "integer",
        validation: {
          max: 100,
          min: 1,
          regex: "^(^[1-9][0-9]*)$",
          regexErrMsg: "OBJECTPROPERTIES.PROVISIONEDOBJECT.PROPERTIES.WRITEUNITS.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  resourceObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.RESOURCEOBJECT.PROPERTIES.NAME.DESCRIPTION",
        key: "Name",
        label: "OBJECTPROPERTIES.RESOURCEOBJECT.PROPERTIES.NAME.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 50,
          minLength: 1,
          regex: "^[{a-zA-Z0-9][-.+_{}a-zA-Z0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.RESOURCEOBJECT.PROPERTIES.NAME.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.RESOURCEOBJECT.PROPERTIES.METHODS.DESCRIPTION",
        hiddenInModal: true,
        key: "Methods",
        label: "OBJECTPROPERTIES.RESOURCEOBJECT.PROPERTIES.METHODS.LABEL",
        type: "array<methodObject>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.RESOURCEOBJECT.PROPERTIES.SUBRESOURCES.DESCRIPTION",
        hiddenInModal: true,
        key: "Subresources",
        label: "OBJECTPROPERTIES.RESOURCEOBJECT.PROPERTIES.SUBRESOURCES.LABEL",
        type: "array<resourceObject>"
      }
    ]
  },
  responseObject: {
    label: "OBJECTPROPERTIES.RESPONSEOBJECT.LABEL",
    properties: [
      {
        description: "OBJECTPROPERTIES.RESPONSEOBJECT.PROPERTIES.TYPE.DESCRIPTION",
        key: "ResponseType",
        label: "OBJECTPROPERTIES.RESPONSEOBJECT.PROPERTIES.TYPE.LABEL",
        onChangeActions: [
          {
            action: "changeStatusCode",
            replaceWith: "actionValue",
            target: "StatusCode"
          }
        ],
        required: true,
        type: "select<typeRes>"
      },
      {
        description: "OBJECTPROPERTIES.RESPONSEOBJECT.PROPERTIES.ERRORCODE.DESCRIPTION",
        key: "StatusCode",
        label: "OBJECTPROPERTIES.RESPONSEOBJECT.PROPERTIES.ERRORCODE.LABEL",
        required: false,
        type: "string",
        validation: {
          maxLength: 3,
          minLength: 3,
          regex: "^[0-9]*$",
          regexErrMsg: "OBJECTPROPERTIES.RESPONSEOBJECT.PROPERTIES.ERRORCODE.VALIDATION.REGEX_ERROR_MSG",
          unique: false
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.RESPONSEOBJECT.PROPERTIES.HEADER.DESCRIPTION",
        key: "ResponseParameters",
        label: "OBJECTPROPERTIES.RESPONSEOBJECT.PROPERTIES.HEADER.LABEL",
        required: false,
        type: "array<HeaderObject>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.RESPONSEOBJECT.PROPERTIES.RESPONSETEMPLATE.DESCRIPTION",
        key: "ResponseTemplates",
        label: "OBJECTPROPERTIES.RESPONSEOBJECT.PROPERTIES.RESPONSETEMPLATE.LABEL",
        required: false,
        type: "array<ResponseTemplateObject>"
      }
    ]
  },
  streamDBObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.STREAMDBOBJECT.PROPERTIES.LAMBDANAME.DESCRIPTION",
        key: "LambdaName",
        label: "OBJECTPROPERTIES.STREAMDBOBJECT.PROPERTIES.LAMBDANAME.LABEL",
        required: true,
        type: "select<node<lambda>>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.STREAMDBOBJECT.PROPERTIES.STARTINGPOSITION.DESCRIPTION",
        key: "StartingPosition",
        label: "OBJECTPROPERTIES.STREAMDBOBJECT.PROPERTIES.STARTINGPOSITION.LABEL",
        type: "select<startingPositionType>",
        validation: {
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.STREAMDBOBJECT.PROPERTIES.STARTINGPOSITION.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.STREAMDBOBJECT.PROPERTIES.BATCHSIZE.DESCRIPTION",
        key: "BatchSize",
        label: "OBJECTPROPERTIES.STREAMDBOBJECT.PROPERTIES.BATCHSIZE.LABEL",
        type: "integer",
        validation: {
          max: 100,
          min: 1,
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.STREAMDBOBJECT.PROPERTIES.BATCHSIZE.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  streamS3Object: {
    properties: [
      {
        description: "OBJECTPROPERTIES.STREAMS3OBJECT.PROPERTIES.LAMBDANAME.DESCRIPTION",
        key: "LambdaName",
        label: "OBJECTPROPERTIES.STREAMS3OBJECT.PROPERTIES.LAMBDANAME.LABEL",
        required: true,
        type: "select<node<lambda>>",
        validation: {
          maxLength: 30,
          minLength: 3,
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.STREAMS3OBJECT.PROPERTIES.LAMBDANAME.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.STREAMS3OBJECT.PROPERTIES.EVENTS.DESCRIPTION",
        key: "Events",
        label: "OBJECTPROPERTIES.STREAMS3OBJECT.PROPERTIES.EVENTS.LABEL",
        required: true,
        type: "select<typeEventS3>",
        validation: {
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.STREAMS3OBJECT.PROPERTIES.EVENTS.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.STREAMS3OBJECT.PROPERTIES.FILTER.DESCRIPTION",
        key: "Filter",
        label: "OBJECTPROPERTIES.STREAMS3OBJECT.PROPERTIES.FILTER.LABEL",
        required: false,
        type: "filterObject",
        validation: {
          regex: "[^\\n]*",
          regexErrMsg: "OBJECTPROPERTIES.STREAMS3OBJECT.PROPERTIES.FILTER.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  streamSQSObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.STREAMSQSOBJECT.PROPERTIES.LAMBDANAME.DESCRIPTION",
        key: "LambdaName",
        label: "OBJECTPROPERTIES.STREAMSQSOBJECT.PROPERTIES.LAMBDANAME.LABEL",
        required: true,
        type: "select<node<lambda>>"
      },
      {
        advanced: true,
        description: "OBJECTPROPERTIES.STREAMSQSOBJECT.PROPERTIES.BATCHSIZE.DESCRIPTION",
        key: "BatchSize",
        label: "OBJECTPROPERTIES.STREAMSQSOBJECT.PROPERTIES.BATCHSIZE.LABEL",
        type: "integer",
        validation: {
          max: 10,
          min: 1,
          regex: "[^\\n]+",
          regexErrMsg: "OBJECTPROPERTIES.STREAMSQSOBJECT.PROPERTIES.BATCHSIZE.VALIDATION.REGEX_ERROR_MSG"
        }
      }
    ]
  },
  ttlObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.TTLOBJECT.PROPERTIES.ATTRIBUTENAME.DESCRIPTION",
        key: "AttributeName",
        label: "OBJECTPROPERTIES.TTLOBJECT.PROPERTIES.ATTRIBUTENAME.LABEL",
        required: false,
        type: "string"
      },
      {
        description: "OBJECTPROPERTIES.TTLOBJECT.PROPERTIES.ENABLED.DESCRIPTION",
        key: "Enabled",
        label: "OBJECTPROPERTIES.TTLOBJECT.PROPERTIES.ENABLED.LABEL",
        required: false,
        type: "boolean"
      }
    ]
  },
  variableObject: {
    properties: [
      {
        description: "OBJECTPROPERTIES.VARIABLEOBJECT.PROPERTIES.NAME.DESCRIPTION",
        key: "Name",
        label: "OBJECTPROPERTIES.VARIABLEOBJECT.PROPERTIES.NAME.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 30,
          minLength: 2,
          regex: "^[A-Za-z0-9-_]*$",
          regexErrMsg: "OBJECTPROPERTIES.VARIABLEOBJECT.PROPERTIES.NAME.VALIDATION.REGEX_ERROR_MSG"
        }
      },
      {
        description: "OBJECTPROPERTIES.VARIABLEOBJECT.PROPERTIES.VALUE.DESCRIPTION",
        key: "Value",
        label: "OBJECTPROPERTIES.VARIABLEOBJECT.PROPERTIES.VALUE.LABEL",
        required: true,
        type: "string",
        validation: {
          maxLength: 200,
          minLength: 1
        }
      }
    ]
  }
};
